import { render, staticRenderFns } from "./SampleReportLayout.vue?vue&type=template&id=0b54415b"
import script from "./SampleReportLayout.vue?vue&type=script&lang=js"
export * from "./SampleReportLayout.vue?vue&type=script&lang=js"
import style0 from "./SampleReportLayout.vue?vue&type=style&index=0&id=0b54415b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports